// @owners { team: patients-team }
import { Button, Column, XsSpacing } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import { type Prescription } from '@alto/scriptdash/alto/patient_app/homescreen/types/v1/prescription';
import { type SourcePrescription } from '@alto/scriptdash/alto/patient_app/homescreen/types/v1/source_prescription';
import React, { useEffect } from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { type Prescription as OGPrescription } from '~shared/types';
import { WaitingOnProgynyTag } from './WaitingOnProgynyTag';

type Props = {
  readonly prescription: SourcePrescription | Prescription | OGPrescription;
  readonly onRxStatusTagPress?: () => void;
  readonly inlineButton?: boolean;
};

const buttonLabel = 'Order early';

export const OrderEarlyCTA = ({ inlineButton, prescription, onRxStatusTagPress }: Props) => {
  const { navigate } = useNavigation();
  const { trackEvent } = useAnalytics();
  const prescriptionId = 'id' in prescription ? prescription.id : null;

  useEffect(() => {
    trackEvent({
      event: EVENTS.PROGYNY_FERTILITY_CYCLE_FORM_PROMPT_VIEWED,
      params: { prescriptionId },
    });
  }, [trackEvent, prescriptionId]);

  if (!prescriptionId) {
    return null;
  }

  const handlePress = () => {
    trackEvent({
      event: EVENTS.PROGYNY_FERTILITY_CYCLE_FORM_PROMPT_PRESSED,
      params: { prescriptionId, prompt: buttonLabel },
    });
    navigate('RouteOrderEarlyForm', { prescriptionId });
  };
  return (
    <Column>
      <WaitingOnProgynyTag onPress={onRxStatusTagPress} />
      <XsSpacing />
      <Button
        onPress={handlePress}
        label={buttonLabel}
        small
        type="secondary"
        width={inlineButton ? 'inline' : undefined}
      />
    </Column>
  );
};
